import DOMPurify from 'dompurify';

/* HTML that people typed into a rich-text field (a job description, from
   the job form), made safe to render.

   It has to be rendered as HTML -- printed as text it shows its own tags,
   "<p>text</p>" -- but rendering it raw lets anything in it run in the
   reader's browser: a <script>, an onerror= on an image, a javascript:
   link. DOMPurify keeps the formatting (paragraphs, lists, bold, links)
   and removes all of that. */
const CONFIG = {
  // Formatting only: nothing that loads or runs anything.
  FORBID_TAGS: ['style', 'iframe', 'object', 'embed', 'form', 'input', 'button'],
  FORBID_ATTR: ['style'],
};

/**
 * @param {string} html
 * @returns {{ __html: string }} ready for dangerouslySetInnerHTML
 */
export const safeHtml = (html) => ({
  __html: DOMPurify.sanitize(String(html || ''), CONFIG),
});
